/**
 * Escala de z-index centralizada del proyecto
 * Define las capas de apilamiento para elementos globales/overlay
 * 
 * 
 * Escala semántica 0-100 con espacio para nuevos valores intermedios
 */

export const zIndex = {
  // Base layer
  base: 0,
  /** Elementos interactivos (Selectores, DatePickers, ActionMenus) */
  dropdown: 20,
  // Navigation & Menu system (20-45)
  /** Overlay invisible para cerrar menús al hacer click fuera */
  menuClickAwayOverlay: 25,
  /** Overlay semi-transparente detrás del mega menú */
  menuContentOverlay: 30,
  /** Dropdown del mega menú y user dropdown */
  menuDropdown: 35,
  /** Barra de navegación principal (TopNavigation) */
  navbar: 40,
  /** Menú lateral móvil (hamburger menu) */
  sideMenu: 45,

  // Floating UI (50-65)
  /** Tooltips informativos */
  tooltip: 60,

  // Global overlays (70-89)
  /** Fondo oscuro del modal */
  modalBackdrop: 70,
  /** Contenido del modal */
  modal: 75,
  /** Fondo del side panel */
  sidePanelOverlay: 80,
  /** Panel lateral derecho */
  sidePanel: 85,

  // Priority elements (90-99)
  /** Notificaciones toast - siempre visibles */
  notification: 95,
} as const;

export type ZIndexKey = keyof typeof zIndex;

